/* eslint-disable max-len */
import React, { FC } from 'react';

import { IconType } from '~/components/Icon/types';

const IconClipboard: FC<IconType> = ({ className, color }) => (
  <svg
    className={className}
    height="100%"
    viewBox="0 0 384 512"
    width="100%"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M384 112v352c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V112c0-26.51 21.49-48 48-48h80c0-35.29 28.71-64 64-64s64 28.71 64 64h80c26.51 0 48 21.49 48 48zM192 40c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24m96 114v-20a6 6 0 0 0-6-6H102a6 6 0 0 0-6 6v20a6 6 0 0 0 6 6h180a6 6 0 0 0 6-6z"
      fill={color || 'currentColor'}
    />
  </svg>
);

export default IconClipboard;
